export {default as polygonArea} from "./src/area";
export {default as polygonCentroid} from "./src/centroid";
export {default as polygonHull} from "./src/hull";
export {default as polygonContains} from "./src/contains";
export {default as polygonLength} from "./src/length";



//////////////////
// WEBPACK FOOTER
// ./~/vue-d3/~/d3-polygon/index.js
// module id = Q5wg
// module chunks = 0